<div id="device-list-component" class="component-inner-wrapper device-list-component-class">
    <main class="main-content">
        <div class="container">
            <!-- <div class="breadcrumb">
                <span>DEVICES</span>
                <span>></span>
                <span class="ele_link" [routerLink]="['/device-list']" >Device List</span>
            </div> -->
            <div class="breadcrumb-wrapper">
              <div class="breadcrumb">
                <span>DEVICES</span>
                <span>></span>
                <span class="ele_link" [routerLink]="['/device-list']">Device List</span>
              </div>


            </div>
            <!-- HTML Toggle Button -->
            <!--
            <div class="page-title-row">
                <div class="page-title">
                    <h1 class="page-title">Device List</h1>
                </div>

                <div class="toggle-wrapper">
                  <div class="toggle-section">
                    <span *ngIf="!toggleValue;else show" class="toggle-label">All times shown in your local time zone</span>
                    <label class="switch">
                      <input type="checkbox" [(ngModel)]="toggleValue"
                      (change)="onToggleTimeMode()">
                      <span class="slider round"></span>
                    </label>
                    <ng-template class="toggle-label" #show>All times shown in UTC</ng-template>
                  </div>
                </div>
            </div> -->
            <div class="aggrid-criteria">
                <div class="grid-filter-criteria device-list-filter-row">
                    <div class="device-list-title">
                        <h1 class="page-title">Device List</h1>
                    </div>
                    <div class="customer-filter">
                        <label class="col-form-label me-2">Customer</label>
                        <select
                          class="custom-dropdown"
                          [(ngModel)]="selectedCustomer"
                          (change)="onHeaderCustomerChange($event)"
                        >
                          <option value="All">{{ customerDropdownSelectLabel }}</option>
                          <option *ngFor="let item of customerList" [value]="item.customerName">
                            {{ item.customerName }}
                          </option>
                        </select>
                    </div>
                    <div class="group-filter">
                        <label class="col-form-label me-2">Group</label>
                        <select
                          class="custom-dropdown"
                          [(ngModel)]="selectedGroup"
                          (change)="onHeaderGroupChange($event)"
                          [disabled]="isGroupDropdownDisabled"
                          name="group"
                        >
                          <option value="">{{ groupDropdownEmptyLabel }}</option>
                          <option *ngFor="let group of groups" [value]="group.groupName">
                            {{ group.groupName }}
                          </option>
                        </select>
                    </div>
                </div>

                <div class="grid-download-csv">
                    <button
                      *appHasPermission="RbacPermissions.DeviceList_Export_Button"
                      class="button-download"
                      (click)="downloadDevices()"
                      [disabled]="isLoading"
                    >
                      <span class="button-icon" *ngIf="!isLoading"><mat-icon>cloud_download</mat-icon></span>
                      <!-- <span class="button-text">Export</span> -->
                      <span class="button-icon" *ngIf="isLoading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </span>
                      <span class="button-text">{{ isLoading ? 'Exporting...' : 'Export' }}</span>
                    </button>
                    <div class="action-bar" *appHasPermission="RbacPermissions.DeviceList_BulkEdit">
                      <a class="custom-link" (click)="$event.preventDefault(); onToggleSelectAll()">{{ selectAllText }}</a>
                      <button class="go-button" (click)="onGo()">Bulk Edit Devices</button>
                    </div>
                  </div>
            </div>
            <!-- Start Action Bar------------ -->
            
            <!-- End Action Bar------------ -->
            <div class="content-wrapper content-wrapper-aggrid">

                <div class="component-ag-grid-wrapper device-list-grid-shell"
                [style.--mc-ag-host-height.px]="gridHostHeightPx"
                [style.--mc-ag-page-size]="loadedRowCount || 1"
                mcAgGridCopyCellTooltip
                (contextmenu)="preventDefaultContextMenu($event)"
                style="position: relative;">
                    <ag-grid-angular #agGrid
                        class="ag-theme-alpine"
                        [style.height.px]="gridHostHeightPx"
                        [style.max-height.px]="gridHostHeightPx"
                        [rowModelType]="'infinite'"
                        [columnDefs]="columnDefs"
                        [defaultColDef]="defaultColDef"
                        [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                        [pagination]="true"
                        [paginationPageSize]="paginationPageSize"
                        [paginationPageSizeSelector]="pageSizeOptions"
                        (cellClicked)="onCellClicked($event)"
                        (gridReady)="onGridReady($event)"
                        [rowSelection]="rowSelection"
                        (rowSelected)="onRowSelected($event)"
                        [cacheBlockSize]="paginationPageSize"
                        [maxBlocksInCache]="1"
                        [suppressRowClickSelection]="true"

                        (paginationChanged)="onPaginationChanged($event)"
                        (filterChanged)="onGridFilterChanged()"
                        (cellContextMenu)="onCellContextMenu($event)"
                        (cellMouseDown)="onCellMouseDown($event)"
                        (cellMouseOver)="onCellMouseOver($event)"
                    >
                    </ag-grid-angular>
                    <div class="custom-context-menu"
                        [ngStyle]="{'top.px': contextMenuPosition.y, 'left.px': contextMenuPosition.x}"
                        *ngIf="contextMenuVisible">
                        <ul>
                            <li (click)="handleCopy()">Copy Value</li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- ------------ -->
            <!-- <div class="col-lg-12 text-right">
                <span>
                  <form>
                    <span style="margin-left: -18px;" class="col-lg-1 mt-2"> <mat-checkbox
                        >Select All in List</mat-checkbox></span>
                    <div class="col-lg-3">
                      <mat-form-field class="col-lg-12 ml-0 pl-0" appearance="fill">
                        <mat-label>Select Company</mat-label>
                        <input type="text" matInput [matAutocomplete]="auto"

                         >
                        <mat-autocomplete #auto="matAutocomplete"  >


                        </mat-autocomplete>
                      </mat-form-field>

                    </div>
                    <div class="col-lg-1 mt-12">
                      <button style="font-size: 14.5px;margin: 1px;"  type="submit"
                       class="primary_button mr-3"
                        value="Submit">Apply</button>
                    </div>


                  </form>
                </span>

              </div> -->
             <!-- ----------------- -->


            <!-- ----start--- -->
<!-- <div class="action-bar">
  <a href="#" class="select-all" (click)="$event.preventDefault();  onSelectAll()">
    Select All in List
  </a>

  <div class="dropdown">
    <button
      class="dropdown-toggle"
      (click)="toggleDropdown()"
      [class.active]="isDropdownOpen"
    >
      Edit Customer
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="dropdown-arrow"
      >
        <path d="m6 9 6 6 6-6"/>
      </svg>
    </button>

    <div class="dropdown-menu" *ngIf="isDropdownOpen">
      <button
        class="dropdown-item"
        *ngFor="let option of ['Option 1', 'Option 2', 'Option 3']"
        (click)="selectOption(option)"
      >
        {{ option }}
      </button>
    </div>
  </div>

  <button class="go-button" (click)="onGo()">
    Go
  </button>
</div> -->

            <!-- ----end--- -->

            


        </div>
    </main>
</div>



